export default function callbacksProcessor() {
  let callbacks = {
    onOrderUpdated: {} // Called when the order was updated on server
  }

  function addCallback(cbName, name, func) {
    try {
      callbacks[cbName][name] = func
    } catch (e) {
      console.error('Invalid callback name in - add (Order)', cbName)
    }
  }

  function removeCallback(cbName, name) {
    try {
      delete callbacks[cbName][name]
    } catch (e) {
      console.error('Invalid callback name in- remove (Order)', cbName)
    }
  }

  function callCallbacks(cbName, message) {
    if (callbacks[cbName] == null) return
    for (let callback of Object.values(callbacks[cbName])) {
      if (typeof callback === 'function') {
        try {
          callback(message)
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  return {
    addCallback,
    removeCallback,
    callCallbacks
  }
}